import React, { ReactNode } from 'react'
import { capitalize } from '../../../helpers/string'
import { theme } from '../../../theme/theme'
import { RegisterUnitItemResidentsContent } from './RegisterUnitItemResidents'
import { IUnitModel } from '../../../interfaces/models/units.interfaces'

interface RegisterUnitItemSectionContentProps {
  title: string
  text?: string
  unit?: IUnitModel
}

export const RegisterUnitItemSectionContent = ({
  title,
  text,
  unit,
}: RegisterUnitItemSectionContentProps): ReactNode => {
  return (
    <div>
      <p style={theme.textVariants.baseBold}>{title}</p>
      {text && (
        <p style={theme.textVariants.base}>{capitalize(text.toLowerCase())}</p>
      )}
      {unit && <RegisterUnitItemResidentsContent unit={unit} />}
    </div>
  )
}
